import { render, staticRenderFns } from "./AccettazioneSsnImpegnativaModalComponent1.vue?vue&type=template&id=6c69a76a&scoped=true"
import script from "./AccettazioneSsnImpegnativaModalComponent1.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnImpegnativaModalComponent1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c69a76a",
  null
  
)

export default component.exports